const NotFound = () => {
  return (
    <>
      <div className="min-h-screen flex items-center justify-center">
        <div>
          <h2 className="mb-0 font-inter text-36 font-semibold leading-44 tracking--02 text-left text-black-1000">
            Error 404
          </h2>
          <p className="mb-[0px] font-inter text-16 font-normal leading-24 text-center text-custom-gray">
            Page Not Found
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
